
// @ts-nocheck
import locale_en_46json_3a96889f from "#nuxt-i18n/3a96889f";
import locale_sv_46json_d79d8e6a from "#nuxt-i18n/d79d8e6a";
import locale_uk_46json_790dc960 from "#nuxt-i18n/790dc960";
import locale_es_46json_464a2c27 from "#nuxt-i18n/464a2c27";

export const localeCodes =  [
  "en",
  "sv",
  "uk",
  "es"
]

export const localeLoaders = {
  en: [
    {
      key: "locale_en_46json_3a96889f",
      load: () => Promise.resolve(locale_en_46json_3a96889f),
      cache: true
    }
  ],
  sv: [
    {
      key: "locale_sv_46json_d79d8e6a",
      load: () => Promise.resolve(locale_sv_46json_d79d8e6a),
      cache: true
    }
  ],
  uk: [
    {
      key: "locale_uk_46json_790dc960",
      load: () => Promise.resolve(locale_uk_46json_790dc960),
      cache: true
    }
  ],
  es: [
    {
      key: "locale_es_46json_464a2c27",
      load: () => Promise.resolve(locale_es_46json_464a2c27),
      cache: true
    }
  ]
}

export const vueI18nConfigs = [
  () => import("#nuxt-i18n/8a9dad50" /* webpackChunkName: "config_i18n_46config_46ts_8a9dad50" */)
]

export const nuxtI18nOptions = {
  restructureDir: "i18n",
  experimental: {
    localeDetector: "",
    switchLocalePathLinkSSR: false,
    autoImportTranslationFunctions: false,
    typedPages: true,
    typedOptionsAndMessages: false,
    generatedLocaleFilePathFormat: "absolute",
    alternateLinkCanonicalQueries: false,
    hmr: true
  },
  bundle: {
    compositionOnly: true,
    runtimeOnly: false,
    fullInstall: true,
    dropMessageCompiler: false,
    optimizeTranslationDirective: true
  },
  compilation: {
    strictMessage: true,
    escapeHtml: false
  },
  customBlocks: {
    defaultSFCLang: "json",
    globalSFCScope: false
  },
  locales: [
    {
      code: "en",
      iso: "en-US",
      domain: "project1882.org",
      files: [
        {
          path: "/opt/render/project/src/apps/refresh/i18n/locales/en.json",
          cache: undefined
        }
      ]
    },
    {
      code: "sv",
      iso: "sv-SE",
      domain: "djurensratt.se",
      files: [
        {
          path: "/opt/render/project/src/apps/refresh/i18n/locales/sv.json",
          cache: undefined
        }
      ]
    },
    {
      code: "uk",
      iso: "uk-UA",
      domain: "ua.project1882.org",
      files: [
        {
          path: "/opt/render/project/src/apps/refresh/i18n/locales/uk.json",
          cache: undefined
        }
      ]
    },
    {
      code: "es",
      iso: "es-ES",
      domain: "es.project1882.org",
      files: [
        {
          path: "/opt/render/project/src/apps/refresh/i18n/locales/es.json",
          cache: undefined
        }
      ]
    }
  ],
  defaultLocale: "en",
  defaultDirection: "ltr",
  routesNameSeparator: "___",
  trailingSlash: false,
  defaultLocaleRouteNameSuffix: "default",
  strategy: "no_prefix",
  lazy: false,
  langDir: "locales",
  rootRedirect: undefined,
  detectBrowserLanguage: false,
  differentDomains: false,
  baseUrl: "",
  customRoutes: "page",
  pages: {},
  skipSettingLocaleOnNavigate: false,
  types: "composition",
  debug: false,
  parallelPlugin: false,
  multiDomainLocales: false,
  i18nModules: []
}

export const normalizedLocales = [
  {
    code: "en",
    iso: "en-US",
    domain: "project1882.org",
    files: [
      {
        path: "/opt/render/project/src/apps/refresh/i18n/locales/en.json",
        cache: undefined
      }
    ]
  },
  {
    code: "sv",
    iso: "sv-SE",
    domain: "djurensratt.se",
    files: [
      {
        path: "/opt/render/project/src/apps/refresh/i18n/locales/sv.json",
        cache: undefined
      }
    ]
  },
  {
    code: "uk",
    iso: "uk-UA",
    domain: "ua.project1882.org",
    files: [
      {
        path: "/opt/render/project/src/apps/refresh/i18n/locales/uk.json",
        cache: undefined
      }
    ]
  },
  {
    code: "es",
    iso: "es-ES",
    domain: "es.project1882.org",
    files: [
      {
        path: "/opt/render/project/src/apps/refresh/i18n/locales/es.json",
        cache: undefined
      }
    ]
  }
]

export const NUXT_I18N_MODULE_ID = "@nuxtjs/i18n"
export const parallelPlugin = false
export const isSSG = false
export const hasPages = true

export const DEFAULT_COOKIE_KEY = "i18n_redirected"
export const DEFAULT_DYNAMIC_PARAMS_KEY = "nuxtI18nInternal"
export const SWITCH_LOCALE_PATH_LINK_IDENTIFIER = "nuxt-i18n-slp"
/** client **/

/** client-end **/